module.exports = __webpack_public_path__ + "img/social_responsibility_book_pic1.d7337311.jpg";